import { just, nothing, type Maybe } from "./maybe";

/**
 * Pure helpers for native import/export dialogs. Every dialog starts in the
 * user's home folder (`~/` on Linux, macOS and Windows). The home path is
 * resolved at the effect edge (`lib/tauri/dialogHome.ts`) and passed in here.
 */

function stripTrailingSeparators(path: string): string {
  let end = path.length;
  while (end > 1 && (path[end - 1] === "/" || path[end - 1] === "\\")) end -= 1;
  return path.slice(0, end);
}

/** Join a home folder and a file name using the separator style of `home`. */
export function joinHomePath(home: string, fileName: string): string {
  const sep = home.includes("\\") && home.includes("/") === false ? "\\" : "/";
  return `${stripTrailingSeparators(home)}${sep}${fileName}`;
}

/** `defaultPath` for a save dialog: `<home>/<fileName>`, or just the name without a home. */
export function saveDialogDefaultPath(
  home: Maybe<string>,
  fileName: string,
): string {
  return home.tag === "just" && home.value !== ""
    ? joinHomePath(home.value, fileName)
    : fileName;
}

/** Options fragment for open / directory dialogs. Omits the key when home is unknown. */
export function openDialogDefaults(
  home: Maybe<string>,
): { defaultPath: string } | Record<string, never> {
  return home.tag === "just" && home.value !== ""
    ? { defaultPath: home.value }
    : {};
}

export function homeFromWire(raw: unknown): Maybe<string> {
  return typeof raw === "string" && raw !== "" ? just(raw) : nothing;
}
